<template>
  <div class="task-breakdown-table">
    <h2>User Summary (by Site)</h2>
    <table>
      <thead>
        <tr class="bold-row">
          <th>Department</th>
          <th>Site</th>
          <th>Total Task Count</th>
          <th>Total Hours</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(item, index) in summaryTable"
          :key="item.department_name + '|' + item.site_name"
          :class="{ 'bold-row': index === summaryTable.length - 1 }"
        >
          <td>{{ item.department_name }}</td>
          <td>{{ item.site_name }}</td>
          <td>{{ item.total_task_count }}</td>
          <td>{{ item.total_minutes }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    summaryTable: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style scoped>
.task-breakdown-table {
  margin: 20px;
  border-collapse: collapse;
  width: 100%;
}

.task-breakdown-table h2 {
  text-align: center;
  margin-bottom: 20px;
}

.task-breakdown-table table {
  width: 100%;
  border-collapse: collapse;
}

.task-breakdown-table th,
.task-breakdown-table td {
  border: 1px solid #ddd;
  padding: 8px;
  text-align: center;
}

.task-breakdown-table th {
  background-color: #f2f2f2;
  color: black;
  padding-top: 12px;
  padding-bottom: 12px;
}

.task-breakdown-table tr:nth-child(even) {
  background-color: #f9f9f9;
}

.task-breakdown-table tr:hover {
  background-color: #ddd;
}

.bold-row {
  font-weight: bold;
}
</style>